import $ from 'jquery';

export function initResearchScan() {

    $(".plugin-research-scan-admin .select2").each(function (idx_select, obj_select) {
        var $this = $(this);
        $this.select2({
            minimumResultsForSearch: -1, dropdownParent: $('.zelftest')
        });
    });

    $(".research-scan-stats .select2").each(function (idx_select, obj_select) {
        var $this = $(this);
        $this.select2({
            width: "100%",
            minimumResultsForSearch: -1,
            dropdownParent: $('.research-scan-stats'),
            placeholder: $(this).data('placeholder'),
        });
    });
    $(".research-scan-report .btn-mail-research-report").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);

        $this.addClass("d-none");

        $(".notify-sending-email").removeClass("d-none");

        $.ajax({
            url: $this.attr("href"), method: "POST", data: {}, dataType: "json", success: function (data) {

                $(".notify-sending-email").addClass("d-none");

                if (typeof data.success != 'undefined' && data.success) {
                    $(".research-scan-report .mail-result .feedback").removeClass("d-none");
                } else {
                    $this.removeClass("d-none");
                    $(".research-scan-report .mail-result .error").removeClass("d-none");
                }

            }
        });
    });
}
